const isSomeObjectValueThruthy = obj => !!Object.values(obj)?.find(el => !!el);
export default {
  isSomeObjectValueThruthy,
};
